module.exports = __webpack_public_path__ + "img/cog.924a4d1f.svg";